import studentApplication from './models/StudentApplicationHelper';

export default { studentApplication };
